import { forwardRef } from 'react';
import Body from './body';
import Button from './button';
import CardInternal from './card-internal';
import Footer from './footer';
import Header from './header';
import HeadstoneAvatar from './headstone-avatar';
var Card = forwardRef(CardInternal);
var CardNamespace = Object.assign(Card, {
    Body: Body,
    Button: Button,
    Footer: Footer,
    Header: Header,
    HeadstoneAvatar: HeadstoneAvatar,
});
export default CardNamespace;
